import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase } from '@material-ui/core';
import { setLeavingModal } from 'containers/Main/actions';
import BannerIcon from './images/banner211.png';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    gap: '1.25rem',
    alignItems: 'center',
    padding: '1.25rem',
    backgroundColor: '#ECF4F8',
  },
  bannerText: {
    margin: 0,
    fontSize: '1rem',
  },
  bannerUrl: {
    color: '#01619B',
  },
  bannerImage: {
    height: '1.875rem',
    width: '4.64288rem',
  },
});

function Banner211Link({ url, text, linkLabel }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleClickOpen = e => {
    e.preventDefault();
    dispatch(
      setLeavingModal({
        visible: true,
        url,
        resourceType: 'pure-url',
      }),
    );
  };

  return (
    <div className={classes.container}>
      <div>
        <ButtonBase component="a" href={url} onClick={handleClickOpen}>
          <img
            className={classes.bannerImage}
            src={BannerIcon}
            alt="211-banner-link"
          />
        </ButtonBase>
      </div>
      <div>
        <div className={classes.bannerText}>
          {text}{' '}
          <a href={url} onClick={handleClickOpen} className={classes.bannerUrl}>
            {linkLabel}
          </a>
        </div>
      </div>
    </div>
  );
}

Banner211Link.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string,
  linkLabel: PropTypes.string,
};

export default Banner211Link;
